<!-- =========================================================================================
    File Name: V2Popover.vue
    Description: .
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="v2_popover_container">
    <div v-if="visible" class="v2_popover_backdrop" @click="closePopover"></div>

    <div v-if="visible" class="v2_popover">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openPopover() {
      this.visible = true;
    },

    closePopover() {
      this.visible = false;
    },
  },

  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style lang="scss">
.v2_popover {
  min-height: 56px;
  width: auto;
  top: 56px;
  right: 0;
  position: absolute;
  background-color: white;
  border-radius: 8px;
  box-shadow: -5px 0px 10px 0px #00000026, 5px 0px 10px 0px #00000026, 0px -5px 10px 0px #00000026, 0px 5px 10px 0px #00000026;
  z-index: 999;
  overflow: hidden;
}

.v2_popover_backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 998;
  background-color: transparent;
}
</style>